
<template>
<!--  <el-dialog :visible.sync="dialogVisible"  @close="handleClose">-->
    <div class="dialog"  v-loading="loading"  :element-loading-text="loadingText">
      <el-form ref="form" :model="form" :rules="formRules" label-width="130px" >
        <el-form-item label="培训项目" prop="title">
          <el-input v-model="form.title" style="width: 100%"></el-input>
        </el-form-item>
        <el-form-item label="培训简介" prop="description">
          <el-input type="textarea" v-model="form.description" maxlength="300" ></el-input>
        </el-form-item>
        <el-form-item label="视频/文档" class="upload-demo">
         <el-upload
              class="video-uploader"
              action="/api/upload_training_media"
              :show-file-list="false"
              :limit="1"
              :disabled=" !!fileInfo.url"
              :on-success="handleUploadSuccess"
              :on-error="handleUploadError"
              :before-upload="beforeVideoUpload"
              :http-request="handleUpload"
              :on-change="handleFileChange"
              :headers="uploadHeaders"
              list-type="picture-card"
              accept=".pdf,video/*"
              ref="uploadRef"
          >
           <div class="upload-custom" style="text-align: center">
             <i class="el-icon-plus icon"></i>
             <span class="text" style="line-height: 24px">点击上传学习内容</span>
           </div>

          </el-upload>
          <div v-if="(fileInfo.mimeType === 'application/pdf' || (dtlId && isPdf)) && fileInfo.url" class="preview pdfFileList" >
            <a v-if="fileInfo.url" @error="handleVideoError"
                @loadeddata="handleLoaded" target="_blank" :href="fileInfo.url">{{fileInfo.name}}</a>
            <i class="el-icon-circle-close" @click=" handleDeleteFile"></i>

          </div>
          <div v-if="fileInfo.mimeType === 'video/mp4' || (dtlId && isVideo)" class="preview" style="position: relative">
            <video controls width="160" height="120" v-if="fileInfo.url" @error="handleVideoError" @loadeddata="handleLoaded">
              <source :src="fileInfo.url" type="video/mp4" />
              您的浏览器不支持视频播放。
            </video>
            <i v-if="fileInfo.url" class="el-icon-circle-close" style="position: absolute;top:0;right: 5px;font-size: 16px;" @click="handleDeleteFile"></i>
          </div>
        </el-form-item>
        <el-form-item label="列表图片" class="upload-demo">
          <el-upload
              action="/api/upload_training_media"
              list-type="picture-card"
              :file-list="fileList2"
              :limit="1"
              accept=".jpg,.png,.jpeg,/*"
              :on-preview="handlePictureCardPreview"
              :http-request="handleUpload2"
              :on-remove="handleRemove2">
            <div class="upload-custom" style="text-align: center">
              <i class="el-icon-plus icon" ></i>
              <span class="text" style="line-height: 24px">点击上传图片</span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="previewDialog" title="图片预览" :modal="false">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="参训人员">
          <select-trainer v-if="dtlId && isShowPeople" :tree-data="orgData"  :selected-ids="form.participants"  @selected="handleSelect"></select-trainer>
          <select-trainer v-if="!dtlId " :tree-data="orgData"    @selected="handleSelect"></select-trainer>
        </el-form-item>
        <el-form-item label="学习时间" prop="studyTime">
          <el-date-picker
              v-model="form.studyTime"
              type="daterange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否需要考试" prop="need_exam" style="margin-bottom: 0;">
          <el-radio v-model="form.need_exam" :label="1">需要</el-radio>
          <el-radio v-model="form.need_exam" :label="0">不需要，完成学习即合格</el-radio>
        </el-form-item>
        <el-form-item label="问题反馈" prop="need_remarks">
          <el-checkbox  v-model="form.need_remarks_temp" style="color:#BD3124">需要参训人员反馈学习心得、体会以及存在的问题</el-checkbox>
        </el-form-item>
      </el-form>
    </div>

</template>
<script>
import axios from "axios";
import {chooseTrainer, getTrainingDtl, saveTraining, updateTraining} from "@/api/training";
import selectTrainer from "@/views/cloudTraining/training/components/selectTrainer.vue";
import pdf from "vue-pdf";

export default {
  name: "addDialog",
  components: {selectTrainer,pdf},
  props: {
    dtlId: {
      type: Number ,
      default: null
    }
  },
  data() {

    return {
      loading: false,
      loadingText: '加载中...',
      isVideo: false,
      isPdf: false,
      numPages: "",
      disabled: false,
      isShowPeople: false,
      previewDialog: false,
      orgData: [],
      fileList: [],
      fileList2: [],
      dialogImageUrl: '',
      token: localStorage.getItem('token') ||localStorage.getItem('vue_token'),
      uploadHeaders: {
        Authorization: `Bearer ${this.token}` // 假设你的后端需要这样的 Authorization 头部格式
      },
      fileInfo: {
        url: '',
        name: '',
        type: '', // 'pdf' 或 'video'
        mimeType: ''
      },
      trainerData:[],
      dialogVisible: false,
      value: [],
      filterMethod(query, item) {
        return item.pinyin.indexOf(query) > -1;
      },
      videoUrl: '',

      form: {
        title: "",
        description: "",
        cover_url: "",
        media_url: "",
        play_time: 50,
        start_time: "",
        end_time: '',
        need_exam: 1,
        need_remarks_temp: true,
        need_remarks: 0,
        studyTime:[],
        participants:[],
        participants_ids: [],
        media_cover_image: '',
      },
      // 校验规则
      formRules: {
        title: [
          { required: true, message: "请输入标题", trigger: "blur" }
        ],
        description: [
          { required: true, message: "请输入描述", trigger: "blur" }
        ],
        need_exam: [
          { required: true, message: "请选择是否需要考试", trigger: "change" }
        ],
        studyTime: [
          { required: true, message: "请选择学习时间", trigger: "change" }
        ],
      }
    };
  },
  created() {
    this.chooseTrainer()

  },
  mounted() {
    setTimeout(()=>{
      if(this.dtlId){
        this.getDtl()
      }
    },1000)
  },
  methods: {
    getDtl(){
      getTrainingDtl({id:this.dtlId}).then(res => {
       let resData = res.data
        this.form.media_url = resData.media_url
        const extension = this.form.media_url.split('.').pop().toLowerCase(); // 获取文件扩展名并转换为小写
        if (extension === 'pdf') {
          this.isPdf = true
          this.isVideo = false
          this.fileInfo.name = this.form.media_url.split('/').pop()
        } else if (extension === 'mp4') {
          this.isVideo = true
          this.isPdf = false
        }
        this.form.title = resData.title
        this.form.description = resData.description
        this.fileInfo.url = resData.media_url
        this.dialogImageUrl = resData.cover_url
        this.form.media_cover_image = resData.media_cover_image
        this.form.studyTime = [resData.start_time,resData.end_time]
        this.form.need_exam = resData.need_exam ? 1 : 0
        this.form.need_remarks_temp = Boolean(resData.need_remarks )
        this.form.participants = resData.participants
        this.form.participants_ids = resData.participants
        this.form.cover_url = resData.cover_url
        this.isShowPeople = true
        if (this.form.cover_url) {
          this.fileList2 = [
            {
              name: '封面图', // 可自定义
              url: this.form.cover_url, // 必须有 url 字段
              uid: '-1', // 唯一标识，建议用时间戳或 id
              status: 'success' // 状态为 success 才会显示为已上传
            }
          ];
        }

      }).catch(error => {
      });
    },

    handleSelect(data){
      this.form.participants_ids = data
    },
    chooseTrainer(){
      chooseTrainer().then(res=>{
        this.orgData = res.data
      })
    },
    handleVideoError(e) {
      // 可在此处 fallback 到封面图 or 提示
    },
    handleLoaded() {
    },
    // 文件选择后触发
    handleFileChange(file, fileList) {
      this.loading = true
      this.loadingText = '文件上传中...'
      this.fileInfo.mimeType = file.raw.type
      if(file.raw.type === 'application/pdf'){
        this.fileInfo.name = file.raw.name
      }

      this.getVideoDuration(file.raw);
    },
    // 核心：获取视频时长
    getVideoDuration(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        const url = URL.createObjectURL(file);

        video.preload = 'metadata';
        video.onloadedmetadata = () => {
          URL.revokeObjectURL(url); // 释放内存
          const duration = video.duration;
          this.form.play_time = Math.floor(duration);
          resolve(duration);
        };

        video.onerror = () => {
          URL.revokeObjectURL(url);
          reject(new Error('无法加载视频'));
        };

        video.src = url;
      });
    },
    handleSubmit(){
      if(!this.form.media_url){
        this.$message.error('请上传视频文件！')
        return false
      }
      if(!this.form.cover_url){
        this.$message.error('请上传封面图！')
      }
      this.$refs.form.validate(valid => {
        if (valid) {
          if(this.form.studyTime){
            this.form.start_time = this.form.studyTime[0]
            this.form.end_time = this.form.studyTime[1]
          }
          if(this.form.need_remarks_temp){
            this.form.need_remarks = 1
          }else{
            this.form.need_remarks = 0
          }
          if(this.dtlId){
            updateTraining({id:this.dtlId,data:this.form}).then((res) => {
              this.$message.success('保存成功！')
            })
          }else{
            saveTraining(this.form).then((res) => {
              this.$message.success('保存成功！')
            })
          }
          this.$emit('closeDialog')
        } else {
          return false;
        }
      });


    },
    handleRemove(file, fileList) {
    },
    handleRemove2(file, fileList) {
      this.fileList2 = []
    },
    beforeVideoUpload(file) {
      const fileType = file.type
      const fileName = file.name.toLowerCase()
      const isPDF = fileName.endsWith('.pdf') && fileType === 'application/pdf'
      const isVideo = fileType.startsWith('video/')

      if (!isPDF && !isVideo) {
        this.$message.error('仅支持上传 PDF 或视频文件！')
        return false
      }

      // 大小限制
      const maxSize = isPDF ? 50 * 1024 * 1024 : 200 * 1024 * 1024 // PDF 50MB，视频 200MB
      if (file.size > maxSize) {
        const maxMB = isPDF ? 50 : 200
        this.$message.error(`${isPDF ? 'PDF' : '视频'}文件大小不能超过 ${maxMB}MB！`)
        this.loading = false
        this.fileInfo.url= ''
        return false
      }

      return true
    },
    handleDeleteFile(){ // 删除培训学习文件
      this.isVideo = false
      this.isPdf = false
      this.fileInfo.url = ''
      this.fileList = []
      this.form.media_url =''
      this.form.media_cover_image = ''
      this.$refs.uploadRef.clearFiles();
    },
    handleUpload(file){
      const formData = new FormData();
      formData.append('file', file.file);
      formData.append('need_thumbnail', 1);
      const config = {
        headers: {
          'Authorization': `Bearer ${this.token}`
        }
      };
      let baseUrl= process.env.VUE_APP_BASE_API
      let fileTemp = file
      axios.post(`${baseUrl}/api/upload_training_media/`, formData, config)
          .then(data => {
            this.loading =false
            // 处理响应
            let resUrl =  data.data.data.media_file
            this.form.media_url = resUrl
            this.form.media_cover_image = data.data.data.media_cover_image
            this.fileInfo.url= resUrl
            this.fileList.push({url: resUrl, name: file.file.name, uid: file.file.uid})
          })
          .catch(error => {
            // 处理错误
          });
    },
    handleUpload2(file){
      this.loading = true
      this.loadingText = '文件上传中...'
      const formData = new FormData();
      formData.append('file', file.file); // 注意：在某些 Element UI 版本中，可能需要使用 file.file 而不是 file.raw
      formData.append('need_thumbnail', 0); // 注意：在某些 Element UI 版本中，可能需要使用 file.file 而不是 file.raw
      const config = {
        headers: {
          'Authorization': `Bearer ${this.token}` // 假设 token 已经在 data 或 computed 中定义
        }
      };
      let baseUrl= process.env.VUE_APP_BASE_API
      axios.post(`${baseUrl}/api/upload_training_media/`, formData, config)
          .then(data => {
            this.loading = false
            // 处理响应
            let resUrl =  data.data.data.media_file
            this.form.cover_url = resUrl
            this.fileInfo.url= resUrl
            this.fileList2.push({url: resUrl, name: file.file.name, uid: file.file.uid})
          })
          .catch(error => {
            // 处理错误
          });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = this.fileList2[0].url;
      this.previewDialog = true
    },
    handleUploadSuccess(response, file, fileList) {
      // 假设后端返回 { url: '...', originalName: 'xxx.pdf', mimeType: 'application/pdf' }
      const { url, originalName, mimeType } = response
      if (!url) {
        this.$message.error('上传失败：未返回文件地址')
        return
      }
      const isPDF = mimeType === 'application/pdf'
      const isVideo = mimeType.startsWith('video/')

      if (isPDF || isVideo) {
        this.fileInfo = {
          url,
          name: originalName || file.name,
          type: isPDF ? 'pdf' : 'video',
          mimeType
        }
        this.$message.success('上传成功！')
      } else {
        this.$message.error('不支持的文件类型')
      }
    },

    handleUploadError(err) {
      this.$message.error('上传失败，请重试')
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-input .el-input__inner{
  width: 100%;
}
::v-deep .el-radio{
  display: block;
  vertical-align: middle;
  line-height: 40px;
}
.upload-demo{
  display: inline-block;
  width: 50%;
  vertical-align: top;
}
::v-deep .el-upload--picture-card{
  width:120px;
  height: 120px;
  line-height: 120px;
  padding:20px 0px;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item{
  width:120px;
  height: 120px;
  line-height: 120px;
}
.video-uploader{
  display: inline-block;
  vertical-align: top;
  margin-right: 10px;
}
.video-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

}
.video-uploader .el-upload:hover {
  border-color: #409eff;
}
.preview{
  display: inline-block;
}
.pdfFileList{
  display: inline-block;
  width: calc(100% - 140px);
  background: #eee;
  padding:0 10px;
  box-sizing: border-box;
  i{
    float: right;
    line-height: 40px;
  }
}
.video-preview {
  margin-top: 10px;
}
//::v-deep .el-upload{
//  display: flex;
//  justify-content: center;
//  align-items: center
//}
.upload-custom {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 10px;
  text-align: center;
  box-sizing: border-box;
}

.upload-custom .icon {
  font-size: 24px;
  color: #888;
  margin-bottom: 8px;
}

.upload-custom .text {
  font-size: 12px;
  color: #000;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #BD3124;
}
::v-deep .el-icon-upload-success.el-icon-check{
  position: absolute;
  top: 0;
  right: 12px;
}
::v-deep .el-dialog__body{
  padding:80px!important;
}
</style>